<div id="backToTopWrapper">
  <div id="backToTopInner" (transitionend)="onTransitionEnd($event)">
    <ab-icon name="arrow-right"
      ><span i18n="common.words|Common Word - Top@@commonWordTop"
        >Top</span
      ></ab-icon
    >
  </div>
</div>
